import styled from 'styled-components';
import { Col, Container } from '@workramp/ui';

export const StyledContainer = styled(Container)`
  padding-top: ${({ theme }) => theme.spacing(6)}px;
`;

export const StyledNoLeftPaddingCol = styled(Col)`
  padding-left: 0;
`;
